'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M18.576 7.544h-2.96c-.125 0-.226.1-.226.224v1.835a.22.22 0 0 1-.066.159l-2.636 2.615a.222.222 0 0 0-.066.158l-.034 6.332c0 .125.1.226.225.226h1.5a4.487 4.487 0 0 0 4.487-4.487V7.768c0-.124-.1-.224-.224-.224Zm-.449.673v6.389a3.818 3.818 0 0 1-3.814 3.814h-1.049l.03-5.696 2.504-2.484a.9.9 0 0 0 .265-.637V8.217h2.064Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M5.733 3c.185 0 .336.151.336.337v2.48h14.123c.185 0 .336.15.336.336v14.511a.337.337 0 0 1-.336.336H5.732a2.734 2.734 0 0 1-2.73-2.676H3V5.732A2.736 2.736 0 0 1 5.733 3Zm14.122 3.49H6.069v9.382a.337.337 0 0 1-.336.337c-1.136 0-2.06.923-2.06 2.059 0 1.135.924 2.059 2.06 2.059h14.122V6.49Zm-10.98 6.423c.186 0 .337.151.337.336v6.024h-.673v-5.687H7.144v-.673h1.73Zm2.72-5.37v11.549h-.673V7.543h.673Zm-6.2-3.842a2.062 2.062 0 0 0-1.722 2.031v10.744a2.73 2.73 0 0 1 1.723-.92Zm3.817 3.842v3.323a.337.337 0 0 1-.337.337H7.143v-.673h1.395V7.543h.674Z",
    fill: "#3F3E4B"
  })));
});
var FwSet0Corneretc = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.FwSet0Corneretc = FwSet0Corneretc;